import request from "@/utils/request";
//1, 网站账号登录
export function accountLogin(data){
    return request({
        url:'/accountLogin',
        data:data,
        method:'post'
    })
}
//2, 检查账号是否存在
export function checkAccountExist(data){
    return request({
        url:'/checkAccountExist',
        data:data,
        method:'get'
    })
}

// 3, 获取登录用的验证码 (Base64 图片)
export function getCaptcha(data){
    // return Promise.resolve(
    //     {
    //         "data": {
    //             "captchaId": "8CkuYbU08Q9JCXQUKzyF",
    //             "image": "data:image/png;base64,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"
    //         },
    //         "err_code": 0,
    //         "err_msg": "OK"
    //     }
    // )
    return request({
        url:'/getCaptcha',
        data:data,
        method:'get'
    })
}

//4, 账号注册
export function addTeam(data){
    // return Promise.resolve({err_code:0})
    return request({
        url:'/addTeam',
        data:data,
        method:'post'
    })
}

//5, 发送短信验证码
export function sendSmsCode(data){
    // return Promise.resolve({err_code:0})
    return request({
        url:'/sendSmsCode',
        data:data,
        method:'post'
    })
}
//6, 账号信息完善（更新）
export function accountUpdateInfo(data){
    return request({
        url:'/web/accountUpdateInfo',
        data:data,
        method:'post'
    })
}
//7, 获取当前登录用户的详细信息
export function getAccountInfo(data){
    return request({
        url:'/any/getAccountInfo',
        data:data,
        method:'get'
    })
}
//8 修改用户密码
export function changeTeamPassword(data){
    return request({
        url:'/changeTeamPassword',
        data:data,
        method:'post'
    })
}
